export default {
    en: {
        demands_page_title                        : "Demands",
        menu_option                               : "Demands",
        demand                                    : "Demand",
        author                                    : "Author",
        createdAt                                 : "Created At",
        modifiedAt                                : "Modified At",
        type_to_search                            : "Type to search...",
        create_demand_button                      : "Create New Demand",
        demand_field_title                        : "Demand Title",
        demand_field_title_placeholder            : "Enter the demand title",
        demand_field_notification_body            : "Notification Body Message",
        demand_field_notification_body_placeholder: "Enter the message that will be displayed in the notification",
        demand_field_description                  : "Demand Description",
        demand_field_description_placeholder      : "Enter the full description for the demand",
        create_button_text                        : "Save Demand",
        cancel_button_text                        : "Go Back",
        validation_title_required                 : "Please enter a title for the demand",
        validation_notification_required          : "Please enter a description for the notification",
        validation_description_required           : "Please enter the full description for the demand",
        demand_delete_modal_title                 : "Demand Deletion",
        demand_delete_confirm_message             : "Do you really want to delete this demand?",
        edit_demand                               : "Edit",
        demand_chat                               : "Chat",
        delete_demand                             : "Delete",
        cancel                                    : "Cancel",
        confirm                                   : "Confirm",
        demands_notification_title                : "Deletion Completed",
        demands_notification_message              : "The deletion of the demand <strong>\"{demandTitle}\"</strong>" +
            " successfully completed",
        display_all                               : "Display All"
    },
    el: {
        demands_page_title                        : "Ζητήσεις",
        menu_option                               : "Ζητήσεις",
        demand                                    : "Ζήτηση",
        author                                    : "Συντάκτης",
        createdAt                                 : "Δημιουργηθηκε",
        modifiedAt                                : "Τροποποιήθηκε",
        type_to_search                            : "Πληκτρολογίστε για αναζήτηση...",
        create_demand_button                      : "Δημιουργια Νεας Ζητησης",
        demand_field_title                        : "Τίτλος Ζήτησης",
        demand_field_title_placeholder            : "Πληκτρολογήστε τον τίτλο της ζήτησης",
        demand_field_notification_body            : "Μήνυμα Ειδοποίησης",
        demand_field_notification_body_placeholder: "Πληκτρολογήστε το μήνυμα της ειδοποίησης",
        demand_field_description                  : "Περιγραφή Ζήτησης",
        demand_field_description_placeholder      : "Εισάγετε την πλήρη περιγραφή της ζήτησης",
        create_button_text                        : "Αποθήκευση Ζήτησης",
        cancel_button_text                        : "Επιστροφή",
        validation_title_required                 : "Παρακαλώ εισάγεται ένα τίτλο για την ζήτηση",
        validation_notification_required          : "Παρακαλώ εισάγεται μια περιγραφή για την ειδοποίηση",
        validation_description_required           : "Παρακαλώ εισάγετε την πλήρη περιγραφή της ζήτησης σας",
        demand_delete_modal_title                 : "Διαγραφή Ζήτησης",
        demand_delete_confirm_message             : "Σίγουρα θέλετε να διαγράψετε αυτή την ζήτηση",
        edit_demand                               : "Επεξεργασία",
        demand_chat                               : "Συνομιλία",
        delete_demand                             : "Διαγραφή",
        cancel                                    : "Άκυρο",
        confirm                                   : "Επιβεβαίωση",
        demands_notification_title                : "Ολοκλήρωση Διαγραφής",
        demands_notification_message              : "Η διαγραφή της ζήτησης <strong>\"{demandTitle}\"</strong> ολοκληρώθηκε" +
            " με επιτυχία.",
        display_all                               : "Προβολή Όλων"
    }
};